import { cn } from '@/lib/utils';
import { obterDefinicaoStatus, type StatusSolicitacao } from '@/features/solicitacoes/status';

interface StatusBadgeProps {
  status: StatusSolicitacao;
  /** Oculta o ícone em espaços muito estreitos. O texto permanece sempre. */
  semIcone?: boolean;
  tamanho?: 'sm' | 'md';
  className?: string;
}

/**
 * Etiqueta de status da solicitação.
 *
 * Acessibilidade: a cor é redundante — o rótulo textual e o ícone carregam a
 * mesma informação, atendendo à diretriz da seção 14 do plano e ao critério
 * 1.4.1 da WCAG (uso de cor).
 */
export function StatusBadge({
  status,
  semIcone = false,
  tamanho = 'md',
  className,
}: StatusBadgeProps) {
  const definicao = obterDefinicaoStatus(status);
  const Icone = definicao.icone;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        tamanho === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        definicao.classes,
        className,
      )}
      title={definicao.descricao}
    >
      {!semIcone && (
        <Icone
          className={tamanho === 'sm' ? 'size-3' : 'size-3.5'}
          aria-hidden="true"
          strokeWidth={2.25}
        />
      )}
      <span>{definicao.rotulo}</span>
      <span className="apenas-leitor-tela">. {definicao.descricao}</span>
    </span>
  );
}
